import Client from '../message-broker/Client';
import store from '../../store';
import CallAction from '../actions/CallAction';

export default class PingBrokerEvent {
  constructor() {
    const queueAgent = store.state.system.queueListenerMessageBroker;
    const agentId = store.state.attendance.Attendance.agentId;
    if (!agentId) return;

    const queuesToSend = ['COMMUNICATOR', 'WHATSAPP'];
    queuesToSend.forEach((queue) => {
      new Client(queueAgent).client.send(
        queue,
        null,
        JSON.stringify(CallAction.sendPongBroker(agentId)),
      );
    });
  }
}
